import type { ReactNode } from "react";

export interface AnalyticsCardProps {
  /** Rótulo en versalitas ("Categorías"). */
  overline?: string;
  title: string;
  description?: string;
  /** Contenido a la derecha del encabezado: una acción o una nota corta ("2 cuotas"). */
  aside?: ReactNode;
  /** `note`: el `aside` se muestra como texto secundario. */
  asideKind?: "note";
  children?: ReactNode;
}

/** Tarjeta de Analítica: rótulo, título, descripción opcional y el contenido de una gráfica o lista. */
export function AnalyticsCard({ overline, title, description, aside, asideKind, children }: AnalyticsCardProps) {
  return (
    <section className="rounded-[var(--ds-radius-lg)] bg-[var(--ds-surface-raised)] p-5 text-[var(--ds-ink)] md:p-6">
      {overline && (
        <div className="text-[11px] font-medium uppercase leading-[14px] tracking-[0.14em] text-[var(--ds-ink-muted)]">{overline}</div>
      )}
      <div className="mb-4 flex flex-wrap items-start justify-between gap-x-3 gap-y-2">
        <div className="min-w-0">
          <h2 className="m-0 mt-1 text-[22px] font-medium leading-7 font-[var(--ds-font-sans)]">{title}</h2>
          {description && (
            <p className="m-0 mt-1 text-sm leading-5 text-[var(--ds-ink-muted)]">{description}</p>
          )}
        </div>
        {aside !== undefined && aside !== null && (
          asideKind === "note"
            ? <span className="text-sm leading-5 text-[var(--ds-ink-muted)]">{aside}</span>
            : aside
        )}
      </div>
      {children}
    </section>
  );
}
